import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  channelListAtom,
  selectedProductAtom,
  userInformationAtom,
} from '../../../Services/_states/index.js';
import TableHeader from '../../Shared/TableHeader/index.jsx';
import { BackButton } from '../../Shared/BackButton/index.jsx';
import FilePreviewSingle from '../../Shared/FileUploadPreview/FilePreviewSingle.jsx';
import FileInput from '../../Shared/FileUploadPreview/FileInput.jsx';
import { ECommerceActions } from '../../../Services/_actions/ECommerce/ecommerce.action.js';
import { ConstantActions } from '../../../Services/_actions/constant.actions.js';
import SelectDropdown from '../../Shared/SelectDropdown/index.jsx';
// import ConfirmBox from '../../Shared/Notification/ConfirmBox';
// import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  InputAdornment,
  Typography,
  Box,
  Button,
} from '@mui/material';
import ErrorWrapper from '../../Shared/ErrorWrapper/index.jsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import BotNumberDropdown from '../../Shared/BotNumberDropdown/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

interface ProductDetailsProps {
  mode: 'Add' | 'Edit' | null;
  backToList: (value: null) => void;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({ mode, backToList }) => {
  const actions = ECommerceActions();
  const constantActoins = ConstantActions();
  const { showSnackBar } = useSnackBar();
  const channelList = useRecoilValue(channelListAtom);
  const [catalogList, setCatalogList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedProduct, setSelectedProduct] = useRecoilState<any>(selectedProductAtom);
  const [updateData, setUpdateData] = useState<any>({});
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [formErrors, setFormErrors] = useState<any>({});
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [filterObj, setFilterObj] = useState<any>({});
  const [refreshFilters, setRefreshFilters] = useState<any>({
    organisation: null,
    organisationId: '',
    bot_number: '',
    catalog_id: '',
  });
  const loggedInUser = useRecoilValue(userInformationAtom);

  const handleSelectOrganisation = (org) => {
    setRefreshFilters({
      ...refreshFilters,
      organisation: org,
      organisationId: org?.organisation_id || '',
      bot_number: '',
      catalog_id: '',
    });

    setFilterObj({
      ...filterObj,
      organisation: org,
      organisationId: org?.organisation_id || '',
      bot_number: '',
      catalog_id: '',
    });

    setCatalogList([]);
  };

  const handleSelectBot = (bot) => {
    const botNumber = bot?.wa_phone_number || bot?.channel_number || '';
    setRefreshFilters((prev) => ({
      ...prev,
      bot_number: botNumber,
      channelObj: bot,
      catalog_id: '',
    }));

    setUpdateData((prev) => ({
      ...prev,
      bot_number: botNumber,
    }));

    setFilterObj((prev) => ({
      ...prev,
      bot_number: botNumber,
      channelObj: bot,
    }));

    if (botNumber) {
      getCatalogList(botNumber);
    } else {
      setCatalogList([]);
    }
  };

  const handleSelectCatalog = (catalog) => {
    setRefreshFilters((prev) => ({
      ...prev,
      catalog_id: catalog?.id || '',
    }));
    setUpdateData((prev) => ({
      ...prev,
      catalog_id: catalog?.id || '',
    }));
  };

  const validateForm = () => {
    const errors: any = {};
    if (!updateData?.bot_number) errors.bot_number = 'Bot Number is required';
    if (!updateData?.catalog_id) errors.catalog_id = 'Catalogue is required';
    if (mode === 'Add') if (!updateData?.name) errors.name = 'Name is required';

    if (isEditing && (!selectedProduct?.price || !/^\d+$/.test(selectedProduct.price))) {
      errors.price = 'Price must be a valid integer (e.g., 10 or 100).';
    }
    // if (isEditing && (!selectedProduct?.price || !/^\d+(\.\d+)?$/.test(selectedProduct.price))) {
    //   errors.price = 'Please enter a valid number (e.g., 10 or 10.99).';
    // }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
    setSelectedProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
  };
  const handleSave = async (e) => {
    e.preventDefault();
    let imageUrl = selectedProduct?.image_url || '';
    if (validateForm()) {
      if (selectedImage) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', selectedImage);
        try {
          const s3Url = await constantActoins.uploadFileS3Bucket(formDataToUpload);
          console.log(s3Url, 's3Url');
          if (s3Url?.status === 200 && s3Url?.data?.data) {
            imageUrl = s3Url?.data?.data?.url ?? '';
          } else {
            console.error('File upload failed', s3Url);
          }
        } catch (error) {
          console.error('Error during image upload', error);
        }
      }
      if (mode === 'Edit') {
        let data = { ...updateData, image_url: imageUrl };
        let res: any = await actions.updateProductItem(data);
        console.log(res, 'resssssss');
        if (res?.status === 200) {
          showSnackBar('Product updated successfully', 'success');
        } else {
          showSnackBar(
            res?.data?.data?.general_error?.message || 'Product not updated successfully',
            'error'
          );
        }
      } else {
        let data = { ...updateData, image_url: imageUrl };
        let res: any = await actions.createProductItem(data);
        if (res?.status === 200) {
          showSnackBar('Product created successfully', 'success');
        } else {
          showSnackBar(
            res?.data?.data?.general_error?.message || 'Product not created successfully',
            'error'
          );
        }
        backToList(null);
        setSelectedProduct({});
      }
      toggleEditMode();
    }
  };

  // const handleSave = async (e) => {
  //   e.preventDefault();
  //   let imageUrl = selectedProduct?.image_url || "";
  //   if (validateForm()) {
  //     if (selectedImage) {
  //       let my_filename = `${Date.now().toString()}${selectedImage?.name}`?.replace(/ /g, '_');
  //       let updatedFile = new File([selectedImage], my_filename, { type: selectedImage?.type });
  //       let s3Url = await constantActoins.uploadFileS3Bucket(updatedFile);
  //       if (s3Url?.$response?.httpResponse?.statusCode === 200)
  //         imageUrl = `${process.env.REACT_APP_IMAGE_URL}/${my_filename}`;
  //     }
  //     if (mode === "Edit") {
  //       let data = { ...updateData, image_url: imageUrl }
  //       let res: any = await actions.updateProductItem(data);
  //       console.log(res, "resssssss")
  //       if (res?.status === 200) {
  //         showSnackBar("Product updated successfully", "success");
  //       } else {
  //         showSnackBar(res?.data?.data?.general_error?.message || "Product not updated successfully", "error")
  //       }
  //     } else {
  //       let data = { ...updateData, image_url: imageUrl };
  //       let res: any = await actions.createProductItem(data);
  //       if (res?.status === 200) {
  //         showSnackBar("Product created successfully", "success");
  //       } else {
  //         showSnackBar(res?.data?.data?.general_error?.message || "Product not created successfully", "error")
  //       }
  //       backToList(null);
  //       setSelectedProduct({});
  //     }
  //     toggleEditMode();
  //   }
  // };

  const onImageSelect = (e) => {
    const file = e?.target?.files[0];

    if (file) {
      if (file.type.startsWith('image/')) {
        setSelectedImage(file);
        setSelectedProduct({
          ...selectedProduct,
          image_url: URL.createObjectURL(file),
        });
      } else {
        showSnackBar('Only image files are allowed.', 'error');
        e.target.value = '';
        setSelectedImage(null);
        setSelectedProduct({
          ...selectedProduct,
          image_url: null,
        });
      }
    }
  };

  const getCatalogList = async (botNumber) => {
    let res = await actions.getCatalogList(botNumber);
    // setCatalogList(res?.data);
    setCatalogList(Array.isArray(res?.data) ? res.data : []);
  };

  // const handleSelectBot = (e) => {
  //   setUpdateData({ ...updateData, bot_number: e?.channel_number });
  //   if (e && e?.channel_number)
  //     getCatalogList(e?.channel_number);
  //   else setCatalogList([])
  // };

  // const handleDeleteProduct = async () => {
  //   const confirmed = await ConfirmBox({
  //     title: 'Confirm Delete Product',
  //     text: 'Are you sure you want to delete this product?',
  //     icon: 'warning',
  //   });

  //   if (confirmed) {
  //     let res = await actions.deleteProductItem(selectedProduct);
  //     if (res?.status === 200)
  //       backToList(null);
  //   }
  // }
  const handleDeleteProduct = async (confirmed: boolean) => {
    setIsConfirmOpen(false);
    if (confirmed) {
      try {
        let res = await actions.deleteProductItem(selectedProduct);
        if (res?.status === 200) {
          backToList(null);
          showSnackBar('Product deleted successfully.', 'success');
        } else {
          console.log(res);
          const {
            response: {
              data: { data: { general_error: { error: { message } } = {} } = {} } = {},
            } = {},
          } = res;

          showSnackBar(
            res?.data?.general_error?.error?.message ||
              'Failed to delete product. Please try again.',
            'error'
          );
        }
      } catch (error) {
        showSnackBar('An error occurred while deleting the product:', 'error');
      }
    }
  };

  const backButton = () => {
    return (
      <BackButton
        onClick={() => {
          setSelectedProduct({});
          backToList(null);
        }}
      />
    );
  };

  // useEffect(() => {
  //   if (mode === "Add")
  //     setIsEditing(true);
  //   else if (selectedProduct?.p_id)
  //     setUpdateData({ ...updateData, p_id: selectedProduct?.p_id, bot_number: selectedProduct?.bot_number });
  //   else
  //     setUpdateData({ ...selectedProduct });
  // }, [])

  useEffect(() => {
    if (mode === 'Add') {
      setIsEditing(true);
    } else if (selectedProduct?.p_id) {
      setUpdateData({
        ...selectedProduct,
        bot_number: selectedProduct.bot_number,
        catalog_id: selectedProduct.catalog_id,
      });
      if (selectedProduct.bot_number) getCatalogList(selectedProduct.bot_number);
    } else {
      setUpdateData({ ...selectedProduct });
    }
  }, []);

  return (
    <Box
      sx={
        {
          // padding: "20px",
          // maxWidth: "900px",
          // margin: "auto",
          // backgroundColor: "#f9f9f9",
          // borderRadius: "8px",
          // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }
      }
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          marginBottom: '20px',
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        {`${mode !== 'Add' ? `Update ${selectedProduct?.name}` : 'Create New Product'}`}
      </Typography>

      {/* <TableHeader headerValue={selectedProduct?.name || 'Product Details'} isBackButton={() => <BackButton onClick={() => backToList(null)} />} /> */}
      <Box>
        <ErrorWrapper error={selectedProduct?.error?.message} />
        {mode === 'Add' && (
          <Grid container spacing={2}>
            {loggedInUser?.is_superuser && (
              <Grid item xs={12} sm={4}>
                <OrganisationDropdown
                  sx={{ minWidth: 165 }}
                  label="Select Organisation"
                  value={refreshFilters.organisation}
                  onChange={handleSelectOrganisation}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={4}>
              <BotNumberDropdown
                sx={{ minWidth: 165 }}
                organisation={
                  loggedInUser?.is_superuser
                    ? refreshFilters.organisation
                    : loggedInUser?.profile?.organisation
                }
                onChange={handleSelectBot}
                value={filterObj?.channelObj || null}
                label="Select Bot Number"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              {(catalogList?.length || 0) > 0 && (
                <SearchableDropdown
                  label="Select Catalog"
                  options={catalogList}
                  value={catalogList.find((item: any) => item.id === updateData.catalog_id) || null}
                  labelKey="name"
                  valueKey="id"
                  onChange={handleSelectCatalog}
                />
              )}
            </Grid>
          </Grid>
        )}
        <Grid container spacing={2} className="pt-2">
          <Grid item xs={12} sm={6} mb={1}>
            <TextField
              fullWidth
              label={
                <Typography component="span">
                  Name <span style={{ color: 'red' }}>*</span>
                </Typography>
              }
              type="text"
              placeholder="Enter Name"
              variant="outlined"
              size="small"
              name="name"
              value={selectedProduct?.name || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
              error={!!formErrors?.name}
              helperText={formErrors?.name}
            />
          </Grid>

          <Grid item xs={12} sm={6} sx={{ mb: { xs: 2, sm: 1 } }}>
            <TextField
              label="Condition"
              name="condition"
              size="small"
              value={selectedProduct?.condition}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="pt-2">
          <Grid item xs={12} sm={6} mb={1}>
            <TextField
              label="Availability"
              name="availability"
              size="small"
              value={selectedProduct?.availability}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>

          <Grid item xs={12} sm={6} mb={1} sx={{ mb: { xs: 2, sm: 1 } }}>
            <TextField
              label="Brand"
              name="brand"
              size="small"
              value={selectedProduct?.brand}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="pt-2">
          <Grid item xs={12} sm={6} mb={1}>
            <TextField
              label="Price"
              name="price"
              size="small"
              value={selectedProduct?.price}
              onChange={handleInputChange}
              fullWidth
              error={!!formErrors?.price}
              helperText={formErrors?.price}
              InputProps={{
                readOnly: !isEditing,
                startAdornment: selectedProduct?.currency && (
                  <InputAdornment position="start">{selectedProduct?.currency}</InputAdornment>
                ),
              }}
              disabled={!isEditing}
            />
          </Grid>

          <Grid item xs={12} sm={6} sx={{ mb: { xs: 2, sm: 1 } }}>
            <TextField
              label="Currency"
              name="currency"
              size="small"
              value={selectedProduct?.currency}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="pt-2">
          <Grid item xs={12} sm={6}>
            <TextField
              label="Quantity to Sell on Facebook"
              name="quantity_to_sell_on_facebook"
              type="number"
              size="small"
              value={selectedProduct?.quantity_to_sell_on_facebook}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="URL"
              name="url"
              size="small"
              multiline
              value={selectedProduct?.url}
              onChange={handleInputChange}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="pt-2">
          <Grid item xs={12} sm={6} mb={1}>
            <Box>
              <Typography variant="h6">Image</Typography>
              {selectedProduct?.image_url && (
                <FilePreviewSingle url={selectedProduct?.image_url} name={selectedProduct?.name} />
              )}
              {isEditing && (
                <Box className="pt-2">
                  <FileInput
                    onFileSelect={onImageSelect}
                    onFileRemove={() => {
                      setSelectedImage(null);
                      setSelectedProduct({ ...selectedProduct, image_url: null });
                    }}
                    file={selectedImage}
                    accept="image/*"
                  />
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} mt={1}>
            <TextField
              label="Description"
              name="description"
              size="small"
              value={selectedProduct?.description}
              onChange={handleInputChange}
              multiline
              rows={3}
              fullWidth
              InputProps={{
                readOnly: !isEditing,
              }}
              disabled={!isEditing}
            />
          </Grid>
        </Grid>
        <Box
          mt={3}
          display="flex"
          justifyContent="flex-end"
          gap={2}
          sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
        >
          <Button variant="outlined" size="small" onClick={() => backToList(null)}>
            Cancel
          </Button>
          {isEditing ? (
            <Button
              variant="contained"
              onClick={(e: any) => handleSave(e)}
              color="primary"
              size="small"
            >
              Save
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={(e: any) => toggleEditMode()}
              color="primary"
              size="small"
            >
              Update
            </Button>
          )}
          {(selectedProduct?.p_id || selectedProduct?.uuid) && (
            <Button variant="outlined" color="error" onClick={() => setIsConfirmOpen(true)}>
              Delete
            </Button>
          )}
        </Box>
      </Box>
      <ConfirmBox
        open={isConfirmOpen}
        onClose={handleDeleteProduct}
        options={{
          title: 'Confirm Delete Product',
          text: 'Are you sure you want to delete this product?',
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
        }}
      />
    </Box>
  );
};

export default ProductDetails;
